<div class="card mb-0 main-card overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">
        Patients
        <span class="badge text-dark bg-body-secondary ms-2">{{ TotalPatients }}</span>
      </h5>
      <div class="d-flex">
        <week-picker (weekDetails)="GetWeekDetails($event)" (weekSelect)="GetSelectedWeek($event)"></week-picker>
        <div class="search-bar">
          <div class="form-group">
            <div class="input-group has-prefix">
              <i class="prefix bi bi-search"></i>
              <input type="text" class="form-control" name="query" placeholder="Search Patient" title="Search Patient" (keyup)="SearchData()" [(ngModel)]="SearchVal" />
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-outline-primary" (click)="ExportData()">Export<i class="bi bi-box-arrow-right fs-5 mx-1"></i></button>
      </div>
    </div>
  </div>
  <div class="card-body table-responsive p-0">
    <table class="table table-x-padding mb-0" *ngIf="TotalPatients || IsLoading">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">
            <button class="btn btn-sm p-0 btn-sort">
              Patient Name
              <i class="text-body-tertiary bi-arrow-down-short"></i>
            </button>
          </th>
          <th scope="col">Phone</th>
          <th scope="col">OV/W</th>
          <th scope="col">D/A</th>
          <th scope="col">D/E</th>
          <th scope="col">Case Type</th>
          <th scope="col">Attorney</th>
          <th scope="col">P/U</th>
          <th scope="col">Disabled</th>
          <th scope="col" class="cell-highlight">Mon.</th>
          <th scope="col" class="cell-highlight">Tue.</th>
          <th scope="col" class="cell-highlight">Wed.</th>
          <th scope="col" class="cell-highlight">Thu.</th>
          <th scope="col" class="cell-highlight">Fri.</th>
          <th scope="col" class="cell-highlight">Sat.</th>
          <th scope="col">Note</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!IsLoading">
          <tr *ngFor="let checklistItem of PatientCheckList; index as i">
            <th scope="row">
              {{ i + 1 + PaginationParams.skip }}
            </th>
            <td>
              <button class="btn btn-link text-black" (click)="OpenEditPopup(checklistItem.patientId)">{{ checklistItem.lastName }} {{ checklistItem.firstName }}</button>
            </td>
            <td>{{ checklistItem.phoneNumber | phonenumber : 'format' }}</td>
            <td>{{ checklistItem.oV_W }}</td>
            <td>{{ checklistItem.dateOfAccident | date : 'MM/dd/yyyy' }}</td>
            <td>{{ checklistItem.dateOfEntry | date : 'MM/dd/yyyy' }}</td>
            <td>{{ checklistItem.caseName }}</td>
            <td>{{ checklistItem.attorneyName }}</td>
            <td class="text-center">
              <i class="bi fs-5" [ngClass]="{ 'bi-check-lg': checklistItem.p_U }"></i>
            </td>
            <td class="text-center">
              <i class="bi fs-5" [ngClass]="{ 'bi-person-wheelchair': checklistItem.disabled }"></i>
            </td>

            <ng-container *ngFor="let weekday of Weekdays">
              <!-- Tooltip data container -->
              <ng-template #tooltipContainer>
                <div class="tooltip-data p-2 text-start">
                  <h6>{{ checklistItem.lastName }} {{ checklistItem.firstName }}</h6>
                  <ng-container *ngFor="let status of PatientCallingStatus">
                    <p class="mb-0" *ngIf="status.key === checklistItem[weekday]"><span class="opacity-50">Status :</span> {{ status.value }}</p>
                  </ng-container>
                  <p class="mb-0"><span class="opacity-50">Note :</span> {{ checklistItem[weekday + 'Note'] ? checklistItem[weekday + 'Note'] : 'N/A' }}</p>
                </div>
              </ng-template>

              <td class="cell-highlight" *ngIf="weekday !== 'sunday'">
                <!-- If Selected week is Past Week -->
                <ng-container *ngIf="SelectedWeekDetails.isPastWeek">
                  <!-- <ng-container *ngFor="let status of PatientCallingStatus">
                    <p class="mb-0" *ngIf="status.key === checklistItem[weekday]" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null">
                      <span class="bi fs-5 bi-check-circle text-success" *ngIf="status.value === 'Confirmed'"></span>
                      <span class="bi fs-5 bi-telephone-x text-danger" *ngIf="status.value === 'No Answer'"></span>
                      <span class="bi fs-5 bi-envelope-arrow-down text-info" *ngIf="status.value === 'Left Message'"></span>
                      <span class="bi fs-5 bi-dash-circle text-danger-emphasis" *ngIf="status.value === 'Not Coming'"></span>
                      <span class="bi fs-5 bi-arrow-repeat text-warning" *ngIf="status.value === 'Resheduled'"></span>
                    </p>
                  </ng-container>
                  <i class="bi fs-5" [ngClass]="{ 'bi-ban opacity-25 text-secondary': !checklistItem[weekday] }"></i> -->
                  <div class="tooltip-holder" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null">
                    <div class="form-group form-check" *ngIf="!checklistItem[weekday]; else IfChecked">
                      <input class="form-check-input" type="checkbox" [checked]="checklistItem[weekday]" id="markAsSelected" (click)="GetMarkConfirmation($event, checklistItem, weekday)" />
                    </div>
                    <ng-template #IfChecked>
                      <ng-container *ngFor="let status of PatientCallingStatus">
                        <p class="mb-0 current-day-checked-checkbox" *ngIf="status.key === checklistItem[weekday]" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null">
                          <input class="hidden-checkbox" type="checkbox" [checked]="checklistItem[weekday]" id="markAsSelected" (click)="GetMarkConfirmation($event, checklistItem, weekday)" />
                          <span class="bi fs-5 bi-check-circle text-success" *ngIf="status.value === 'Confirmed'"></span>
                          <span class="bi fs-5 bi-telephone-x text-danger" *ngIf="status.value === 'No Answer'"></span>
                          <span class="bi fs-5 bi-envelope-arrow-down text-info" *ngIf="status.value === 'Left Message'"></span>
                          <span class="bi fs-5 bi-dash-circle text-danger-emphasis" *ngIf="status.value === 'Not Coming'"></span>
                          <span class="bi fs-5 bi-arrow-repeat text-warning" *ngIf="status.value === 'Resheduled'"></span>
                        </p>
                      </ng-container>
                    </ng-template>
                  </div>
                </ng-container>

                <!-- If Selected week is Current Week -->
                <ng-container *ngIf="SelectedWeekDetails.isCurrentWeek">
                  <!-- In Current Week If Day is Same day as Today -->
                  <ng-container *ngIf="weekday === (TodayDate.getDay() | weekdayName); else elseBlock">
                    <div class="tooltip-holder" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null">
                      <div class="form-group form-check" *ngIf="!checklistItem[weekday]; else IfChecked">
                        <input class="form-check-input" type="checkbox" [checked]="checklistItem[weekday]" id="markAsSelected" (click)="GetMarkConfirmation($event, checklistItem, weekday)" />
                      </div>
                      <ng-template #IfChecked>
                        <ng-container *ngFor="let status of PatientCallingStatus">
                          <p class="mb-0 current-day-checked-checkbox" *ngIf="status.key === checklistItem[weekday]" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null">
                            <input class="hidden-checkbox" type="checkbox" [checked]="checklistItem[weekday]" id="markAsSelected" (click)="GetMarkConfirmation($event, checklistItem, weekday)" />
                            <span class="bi fs-5 bi-check-circle text-success" *ngIf="status.value === 'Confirmed'"></span>
                            <span class="bi fs-5 bi-telephone-x text-danger" *ngIf="status.value === 'No Answer'"></span>
                            <span class="bi fs-5 bi-envelope-arrow-down text-info" *ngIf="status.value === 'Left Message'"></span>
                            <span class="bi fs-5 bi-dash-circle text-danger-emphasis" *ngIf="status.value === 'Not Coming'"></span>
                            <span class="bi fs-5 bi-arrow-repeat text-warning" *ngIf="status.value === 'Resheduled'"></span>
                          </p>
                        </ng-container>
                      </ng-template>
                    </div>
                  </ng-container>

                  <!-- In Current Week If Day is Not Same day as Today -->
                  <ng-template #elseBlock>
                    <!-- The Day is Previous days then Current day-->
                    <div class="previous-days" *ngIf="TodayDate.getDay() > Weekdays.indexOf(weekday)">
                      <div class="tooltip-holder" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null">
                        <div class="form-group form-check" *ngIf="!checklistItem[weekday]; else IfChecked">
                          <input class="form-check-input" type="checkbox" [checked]="checklistItem[weekday]" id="markAsSelected" (click)="GetMarkConfirmation($event, checklistItem, weekday)" />
                        </div>
                        <ng-template #IfChecked>
                          <ng-container *ngFor="let status of PatientCallingStatus">
                            <p class="mb-0 current-day-checked-checkbox" *ngIf="status.key === checklistItem[weekday]" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null">
                              <input class="hidden-checkbox" type="checkbox" [checked]="checklistItem[weekday]" id="markAsSelected" (click)="GetMarkConfirmation($event, checklistItem, weekday)" />
                              <span class="bi fs-5 bi-check-circle text-success" *ngIf="status.value === 'Confirmed'"></span>
                              <span class="bi fs-5 bi-telephone-x text-danger" *ngIf="status.value === 'No Answer'"></span>
                              <span class="bi fs-5 bi-envelope-arrow-down text-info" *ngIf="status.value === 'Left Message'"></span>
                              <span class="bi fs-5 bi-dash-circle text-danger-emphasis" *ngIf="status.value === 'Not Coming'"></span>
                              <span class="bi fs-5 bi-arrow-repeat text-warning" *ngIf="status.value === 'Resheduled'"></span>
                            </p>
                          </ng-container>
                        </ng-template>
                      </div>
                      <!-- <ng-container *ngFor="let status of PatientCallingStatus">
                        <p class="mb-0" [ngbTooltip]="checklistItem[weekday] ? tooltipContainer : null" *ngIf="status.key === checklistItem[weekday]">
                          <span class="bi fs-5 bi-check-circle text-success" *ngIf="status.value === 'Confirmed'"></span>
                          <span class="bi fs-5 bi-telephone-x text-danger" *ngIf="status.value === 'No Answer'"></span>
                          <span class="bi fs-5 bi-envelope-arrow-down text-info" *ngIf="status.value === 'Left Message'"></span>
                          <span class="bi fs-5 bi-dash-circle text-danger-emphasis" *ngIf="status.value === 'Not Coming'"></span>
                          <span class="bi fs-5 bi-arrow-repeat text-warning" *ngIf="status.value === 'Resheduled'"></span>
                        </p>
                      </ng-container>
                      <i class="bi fs-5" [ngClass]="{ 'bi-ban opacity-25 text-secondary': !checklistItem[weekday] }"></i> -->
                    </div>

                    <!-- The Day is Next days then Current day-->
                    <!--  
                      <div class="next-days" *ngIf="TodayDate.getDay() < Weekdays.indexOf(weekday)">
                        <div class="form-group form-check">
                          <input class="form-check-input" type="checkbox" value="" id="futureDay" disabled />
                        </div>
                      </div> 
                    -->
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="SelectedWeekDetails.isFutureWeek">
                  <!-- 
                    <div class="form-group">
                      <input class="form-check-input" type="checkbox" value="" id="futureDay" disabled />
                    </div> 
                  -->
                </ng-container>
              </td>
            </ng-container>

            <td class="text-end w-25 p-1">
              <div class="form-group notes">
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="checklistItem.note" id="note" placeholder="Note" />
                </div>
              </div>
            </td>
          </tr>
        </ng-container>

        <ng-container *ngIf="IsLoading">
          <tr *ngFor="let employee of ['', '', '', '', '']; index as i">
            <td *ngFor="let employee of ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']; index as i">
              <p class="placeholder-glow">
                <span class="placeholder col-12"></span>
              </p>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div class="empty-data-placeholder" *ngIf="!TotalPatients && !IsLoading">
      <div class="text-center">
        <h3 class="text-body-tertiary"><i class="bi bi-exclamation-triangle"></i> Oops..!</h3>
        <p>No Patients Found</p>
      </div>
    </div>
  </div>

  <div class="card-footer">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <p class="mb-0 opacity-50">Status -</p>
        <ul class="patient-status-legend mb-0">
          <li *ngFor="let status of PatientCallingStatus">
            <ng-container *ngIf="status.value === 'Confirmed'">
              <span class="bi bi-check-circle text-success"> </span>
              <span class="ms-2 text-secondary">{{ status.value }}</span>
            </ng-container>
            <ng-container *ngIf="status.value === 'No Answer'">
              <span class="bi bi-telephone-x text-danger"> </span>
              <span class="ms-2 text-secondary">{{ status.value }}</span>
            </ng-container>
            <ng-container *ngIf="status.value === 'Left Message'">
              <span class="bi bi-envelope-arrow-down text-info"> </span>
              <span class="ms-2 text-secondary">{{ status.value }}</span>
            </ng-container>
            <ng-container *ngIf="status.value === 'Not Coming'">
              <span class="bi bi-dash-circle text-danger-emphasis"> </span>
              <span class="ms-2 text-secondary">{{ status.value }}</span>
            </ng-container>
            <ng-container *ngIf="status.value === 'Resheduled'">
              <span class="bi bi-arrow-repeat text-warning"> </span>
              <span class="ms-2 text-secondary">{{ status.value }}</span>
            </ng-container>
          </li>
          <li>
            <span class="bi bi-ban opacity-25 text-secondary'"> </span>
            <span class="ms-2 text-secondary">Not attended</span>
          </li>
        </ul>
      </div>
      <app-pagination [totalItems]="TotalPatients" [pageSize]="PaginationParams.take" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" />
    </div>
  </div>
</div>
